var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"micro-radil-chart"},[_c('RkEcharts',{ref:"radial",attrs:{"height":"100%","option":_vm.responseConfig}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }